<div class="container-hours-dates">
    <div class="d-flex justify-content-between align-items-center">
        <span class="title-hours-dates-event">
            {{ sessionSelectionOnly ? 'Seleccionar sesión:' : 'Seleccionar fecha y hora:' }}
        </span>
        <i class="fa-light fa-times fa-lg pointer-in" (click)="closeHoursEmit()"></i>
    </div>

    <div class="title-calendar">
        <!-- <i class="fa-light fa-calendar"></i>
        <p>24 de enero a las 22:00</p> -->
    </div>

    <!-- Calendar - Siempre mostrar -->
    <div class="container-calendar-event">
        <div class="options-swiper d-flex align-items-center justify-content-between">
            <div class="button-swiper-custom button-prev-custom pointer-in">
                <i class="fa-light fa-chevron-left"></i>
            </div>
            <div class="button-swiper-custom button-next-custom pointer-in">
                <i class="fa-light fa-chevron-right"></i>
            </div>
            <swiper #swiperMonths class="swiper swiper-custom-events" [config]="swiperMonthsConfig">
                <ng-template *ngFor="let option of monthsOptions" swiperSlide>
                    <div (click)="goToMonth(dp, option.value)" class="swiper-months"
                        [class.monthActive]="currentMonth == option.value.month">
                        <p class="m-0">{{ option.string }}</p>
                    </div>
                </ng-template>
            </swiper>
        </div>

        <ngb-datepicker class="custom-datepicker-event" #dp [displayMonths]="1" [dayTemplate]="t" outsideDays="hidden"
            (dateSelect)="changeDateSelected($event)" [minDate]="minDate" navigation="none">

            <ng-template #t let-date let-focused="focused">
                <span class="custom-day-event" [class.focused]="hoveredDate != null"
                    [class.select-day]="selectedDate && date.day == selectedDate.day && date.month == selectedDate.month && date.year == selectedDate.year"
                    [class.disabled]="dayDisabled(date)" [class.faded]="isHovered(date)"
                    (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                    <span class="inside-day-event" [class.weekend]="isWeekend(date)">{{ date.day }}</span>
                </span>
            </ng-template>
        </ngb-datepicker>
    </div>

    <!-- Hours - Siempre mostrar si hay opciones de hora -->
    <mat-divider class="divider-hour"></mat-divider>
    <div *ngIf="optionsHours.length > 0">
        <div class="container-hours-event">
            <div class="chip-hour"
                [class.d-none]="numDaySelect == null || !hour.sessions.includes(dateString) || shouldHideHourChipForTime(hour, dateString)"
                [class.activeChip]="hourSelected==hour" (click)="onHourChipClick(hour)" *ngFor="let hour of optionsHours">
                <span *ngIf="hour.sessions.includes(dateString) && !shouldHideHourChipForTime(hour, dateString)">{{ hour.time }}h</span></div>
        </div>
        <mat-divider class="divider-hour"></mat-divider>
    </div>
    <!-- texto informativo sobre la fecha y hora seleccionadas - Siempre mostrar -->
    <div class="info-selected">
        <div class="info-selected-item">
            <i class="fal fa-calendar icon-primary"></i>
            <span [class.selected-item]="selectedDate">{{selectedDate?formatStringDate(selectedDate,
                'dd')+' de '+(formatStringDate(selectedDate, 'MMMM')|titlecase):'Seleccionar fecha'}}</span>
        </div>
        <div class="info-selected-item" *ngIf="optionsHours.length > 0">
            <i class="fal fa-clock icon-primary"></i>
            <span [class.selected-item]="hourSelected">
                {{hourSelected?(hourSelected.time)+'h':'Seleccionar hora'}}
            </span>
        </div>
    </div>


    <!-- Entradas -->
    <!-- En modo sessionSelectionOnly, no mostrar botones ni tickets -->
    <div *ngIf="!sessionSelectionOnly && (!event.map_version || !event.space)">
        <div class="continar-tickets-event" *ngIf="optionsTickets?.length > 0 && !soldOut">
            <div class="select-ticket-type-wrapper">
                <div class="select-ticket-placeholder d-flex align-items-center justify-content-between pointer-in"
                    (click)="openSelect(true)">
                    <span>Seleccionar entrada</span>
                    <ng-container *ngIf="optionsDates.length > 0">
                        <i *ngIf="isSelectorOpen" class="fa-light fa-angle-down" style="color: var(--color-primary);"></i>
                        <i *ngIf="!isSelectorOpen" class="fa-light fa-angle-right" style="color: var(--color-primary);"></i>
                    </ng-container>
                    <i *ngIf="optionsDates.length === 0" class="fa-light fa-circle-info" style="color: var(--color-primary);"></i>
                </div>

                <div class="ticket-selector-wrapper" [ngClass]="{ 'open': isSelectorOpen, 'closed': !isSelectorOpen }">
                    <p class=" ticket-type-option pointer-in" (click)="addTicketOption(option)"
                        [class.disableTicket]="singleTicketOnly && selectTickets.length > 0"
                        *ngFor="let option of enabledTickets">
                        {{ option.name }}</p>
                </div>
            </div>

            <div class="list-select-tickets" *ngIf="selectTickets.length > 0">
                <div class="d-flex align-items-center justify-content-between" *ngFor="let option of selectTickets">
                    <span class="name-ticket">{{ option.ticket.name }}</span>
                    <!-- Abonos y entradas nominativas: cantidad fija de 1 -->
                    <div *ngIf="singleTicketOnly" class="ticket-quantity-fixed">
                        <span>Cantidad: 1</span>
                    </div>
                    <!-- Para flujo normal, mostrar botones de incremento/decremento -->
                    <div *ngIf="!singleTicketOnly" class="section-number-tickets d-flex align-items-center">
                        <span class="btn-change-ticket" (click)="changeTypeTicket(option, 'delete')">-</span>
                        <input class="number-ticket" type="number" min="1" max="10" [value]="option.number">
                        <span class="btn-change-ticket" (click)="changeTypeTicket(option, 'add')">+</span>
                    </div>
                </div>
            </div>

            <!-- Entradas nominativas: avisar antes de comprar, no después -->
            <div class="nominative-notice" *ngIf="isNominative">
                <i class="fa-light fa-id-card icon-primary"></i>
                <div>
                    <p class="nominative-notice-title m-0">Entrada nominativa</p>
                    <p class="m-0">
                        Se emitirá a tu nombre y solo puedes comprar 1 entrada por sesión. En el acceso te pedirán el
                        mismo documento de identidad con el que la compras.
                    </p>
                </div>
            </div>
        </div>

        <!-- Total -->
        <div class="section-total-price d-flex justify-content-between align-items-center"
            *ngIf="event?.preciodesde != 0 && !soldOut">
            <p>Total</p>
            <p>{{ priceTotal | number:'2.2-2' }}€</p>
        </div>

        <!-- Button -->
        <div class="w-100" *ngIf="(!event?.informativo || !event.external) && !soldOut">
            <button class="w-100 btn-buy"
                [class.disabled]="addingToCart || numDaySelect == null || ((optionsHours.length > 0 && !hourSelected) || optionsHours.length <= 0) || (selectTickets.length <= 0) || soldOut"
                (click)="goBuyTickets()">
                <span *ngIf="addingToCart">Añadiendo...</span>
                <span *ngIf="!addingToCart && fromAbono">Elegir entradas</span>
                <ng-container *ngIf="!addingToCart && !fromAbono">
                    Añadir
                    <i class="fa-light fa-cart-plus" style="font-size: 16px;"></i>
                </ng-container>
            </button>
            <!-- Comprobar si tiene entradas tipo festival -->
            <button class="w-100 btn-buy" *ngIf="bondEnabled" (click)="goBuyTickets()">
                Comprar
                <!-- Nombre abono -->
                <i class="fa-light fa-cart-plus" style="font-size: 16px;"></i>
            </button>
        </div>
    </div>

    <!-- Información de error -->
    <div class="info-error-message mt-3">
        <div *ngIf="error" class="error-message">
            <i class="fa-light fa-triangle-exclamation"></i>
            <p>{{ error }}</p>
        </div>
    </div>

    <!-- Renderizar botones para eventos con mapa o en modo sessionSelectionOnly -->
    <div *ngIf="sessionSelectionOnly || (event.map_version && event.space)">
        <ng-container *ngTemplateOutlet="divOpenMap"></ng-container>
    </div>

    <ng-template #divOpenMap>
        <!-- Button Seats - Solo mostrar si NO estamos en modo sessionSelectionOnly -->
        <div class="w-100" *ngIf="!sessionSelectionOnly">
            <button class="w-100 btn-buy" (click)="openSeatPanel()" [class.loading]="openingSeats"
                [class.disabled]="openingSeats || numDaySelect == null || ((optionsHours.length > 0 && !hourSelected) || optionsHours.length <= 0)">
                <span *ngIf="!openingSeats">Elegir entradas</span>
                <span *ngIf="openingSeats">
                    <i class="fa-light fa-spinner-third fa-spin" style="font-size: 16px;"></i>
                    Cargando mapa...
                </span>
            </button>
        </div>
        <!-- Button para confirmar sesión - Solo mostrar en modo sessionSelectionOnly -->
        <div class="w-100" *ngIf="sessionSelectionOnly">
            <button class="w-100 btn-buy" (click)="confirmSessionSelection()"
                [class.disabled]="numDaySelect == null || ((optionsHours.length > 0 && !hourSelected) || optionsHours.length <= 0)">
                Continuar
            </button>
        </div>
    </ng-template>
</div>